import React from 'react'
import { required } from 'react-admin'
import { locationFeatureCategoryChoices } from 'services/cfg/form'
import CatalogItemBaseForm, {
  CatalogItemBaseFormProps,
} from 'ui-shared/Forms/CatalogItemBaseForm'
import KToolTip from 'ui-shared/KTooltip'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'
import SingleImageInput from 'ui-shared/WrappedInputs/SingleImageInput'

const LocationFeatureForm: React.FC<CatalogItemBaseFormProps> = (props) => {
  return (
    <CatalogItemBaseForm {...props}>
      <KToolTip title="tooltip.hint.locationFeatureImage">
        <SingleImageInput accept=".png" />
      </KToolTip>
      <KSelectInput
        source="category"
        choices={locationFeatureCategoryChoices}
        validate={required()}
      />
    </CatalogItemBaseForm>
  )
}

export default LocationFeatureForm
